'use strict';

var WizardTransitionButtonsDirective = function WizardTransitionButtonsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/wizard-transition-buttons.html')
  };
};
WizardTransitionButtonsDirective.$inject = [];
module.exports = WizardTransitionButtonsDirective;